import { RiskManagerComponent } from './risk-manager.component';
import { DashboardModule } from './../dashboard/dashboard.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from '../common/ui.module';

@NgModule({
    imports: [
        CommonModule,
        UIModule,
        DashboardModule,
    ],
    declarations: [
        RiskManagerComponent,
    ],
    exports: [
        RiskManagerComponent,
    ]
})
export class RiskModule {

}
